<template>
  <div class="main-body">
    <div class="header">房态图</div>
    <div class="out">
      <div class="search2">

        <div style="float:right">

          <el-select v-model="institutionCode" @change="insChange" placeholder="请选择机构" style="margin-right: 5px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-select v-model="buildingCode" clearable placeholder="请选择楼宇" @change="buildingChange" style="margin-right: 5px">
            <el-option
                v-for="item in arr_building"
                :key="item.buildingCode"
                :label="item.name"
                :value="item.buildingCode">
            </el-option>
          </el-select>

          <el-select v-model="floor" clearable placeholder="请选择楼层" style="margin-right: 5px">
            <el-option
                v-for="item in arr_floor"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>

      <div :style="styleTh">

        <div style="padding:0px 10px;font-size:18px">

          <div style="float:left;">
            <span class="num1">楼宇数:<span class="num2">{{buildingSum}}</span></span>
            <span class="num1">房间数:<span class="num2">{{roomSum}}</span></span>
            <span class="num1">床位总数:<span class="num2">{{berthSum}}</span></span>
            <!--            <span class="num1">预约床位数:<span class="num2">{{berthStatus1}}</span></span>-->
            <span class="num1">已住床位数:<span class="num2">{{berthStatus1}}</span></span>
            <span class="num1">空闲床位数:<span class="num2">{{berthStatus0}}</span></span>
            <span class="num1">空置率：<span class="num2">{{(baiFenBi)}}%</span></span>
          </div>

          <div style="clear:both;hegiht:0"></div>
        </div>

        <el-divider></el-divider>

        <div v-for="buildingItem in list" :key="buildingItem">

          <div style="margin:10px;font-size:18px;">楼宇：{{buildingItem.name}}</div>

          <div v-for="roomItem in buildingItem.listRoomDTO" :key="roomItem">
            <el-card class="box-card">

              <div slot="header" class="clearfix">
                <div style="float:left;">
                  <span>房号：</span><span>{{roomItem.number}}</span>
                </div>

                <div style="float:right;">
                  <span style="color:#909399;margin-right:10px;">空闲：<span style="color:#909399;">{{getStatus(roomItem.listBerthDTO,0)}}</span></span>
                  <span style="color:#909399;margin-right:10px;">已入住：<span style="color:red;">{{getStatus(roomItem.listBerthDTO,1)}}</span></span>
                </div>
                <div style="clear:both;"></div>
              </div>

              <div class="text item" style="text-align:center;">

                <div style="display: inline-block;padding:0px 10px;"
                     v-for="berthItem in roomItem.listBerthDTO" :key="berthItem">

                  <el-popover placement="top-start" width="300" trigger="hover">
                    <div>状态：{{getBerthStatus(berthItem.status)}}</div>
                    <div v-if="berthItem.checkin!=null">姓名：{{berthItem.checkin.elderlyName}}</div>
                    <div v-if="berthItem.checkin!=null">联系方式：{{berthItem.checkin.phone}}</div>
                    <div v-if="berthItem.checkin!=null">性别：{{getSex(berthItem.checkin.gender)}}</div>
                    <div v-if="berthItem.checkin!=null">年龄：{{berthItem.checkin.age}}</div>
                    <div>床号：{{berthItem.number}}</div>
                    <div v-if="berthItem.checkin!=null">入住开始时间：{{formatterTime(berthItem.checkin.beginTime)}}</div>
                    <el-image slot="reference" v-if="berthItem.status==0" style="width: 50px; height: 50px;" :src="url3"></el-image>
                    <el-image slot="reference" v-if="berthItem.status==1" style="width: 50px; height: 50px;" :src="url2"></el-image>
                    <!--                    <el-image slot="reference" v-if="berthItem.status==2" style="width: 50px; height: 50px;" :src="url2"></el-image>-->
                  </el-popover>

                  <div style="color:#909399;">{{berthItem.number}}</div>

                </div>

              </div>

            </el-card>
          </div>

          <div style="clear:both;hegiht:0"></div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{

      url1:require('@/assets/berth/chuangLanDa.png'),
      url2:require('@/assets/berth/chuangHongDa.png'),
      url3:require('@/assets/berth/chuangHuiDa.png'),


      listAll:null,
      list:this.listAll,

      buildingSum:0,
      roomSum:0,
      berthSum:0,

      berthStatus0:0,
      berthStatus1:0,
      berthStatus2:0,
      baiFenBi:0,

      listDTO:[],

      styleTh:{
        height:'',
        background:'#fff',
        'overflow-y':'auto'
      },

      arr_ins:[],
      institutionCode: '',

      arr_building:[],
      buildingCode: '',

      arr_floor:[],
      floor: '',


    }
  },
  created(){
    this.getIns();
    this.styleTh.height=this.$store.state.tableHeight+50+'px';
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
      this.styleTh.height=val+50+'px';
    },
  },
  methods:{

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
            this.getBuild();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    getBuild(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Building/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.arr_building = response.data.data;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })

    },

    insChange(val){
      this.institutionCode = val;

      this.arr_building = [];
      this.buildingCode = '';
      this.getBuild();

      this.arr_floor = [];
      this.floor = '';

    },
    buildingChange(val){
      this.buildingCode=val;

      var floor='';
      for(var i in this.arr_building){
        if(this.arr_building[i].buildingCode==val){
          floor=this.arr_building[i].floor
        }
      }

      var list=[];
      for(var j=0;j<floor;j++){
        var listValue={}
        listValue.label=j+1;
        listValue.value=j+1;
        list.push(listValue)
      }
      this.arr_floor=list;
      this.floor='';

    },



    getBerthStatus(value){
      if(value==0){
        return "空闲"
      }else if(value==1){
        return "已住"
      }else if(value==11){
        return "已禁用"
      }else{
        return "未知"
      }
    },
    getSex(gender){
      if(gender==0){
        return "女"
      }else if(gender==1){
        return "男"
      }else {
        return "未知"
      }
    },
    formatterTime(value) {
      return value?value.replace('T',' ').slice(0,19):null
    },
    getStatus(list,num){
      let count = 0;
      for(let i=0;i<list.length;i++){
        if(list[i].status==num){
          count++;
        }
      }
      return count;
    },


    getList(){
      this.tableload=true


      this.buildingSum = 0;
      this.roomSum = 0;
      this.berthSum = 0;
      this.berthStatus0=0;
      this.berthStatus1 = 0;
      this.baiFenBi = 0;



      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Berth/GovRoomState",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          buildingCode:this.buildingCode,
          floor:this.floor==''?-1:this.floor,
        }
      }).then( (response)=> {
        if(response.data.error == 0){

          this.listAll = response.data.data;
          this.list = response.data.data;
          this.buildingSum = this.list.length;

          //统计数量
          for(let i=0;i<this.list.length;i++){
            this.roomSum = this.roomSum+ this.list[i].listRoomDTO.length;

            for(let j=0;j<this.list[i].listRoomDTO.length;j++){
              let listBerth = this.list[i].listRoomDTO[j].listBerthDTO;
              this.berthSum = this.berthSum+listBerth.length;

              for(let k=0;k<listBerth.length;k++){
                if(listBerth[k].status==0){
                  this.berthStatus0++;
                }else if(listBerth[k].status==1){
                  this.berthStatus1++;
                }
                // else if(listBerth[k].status==2){
                //   this.berthStatus2++;
                // }
              }

            }
          }
          this.baiFenBi = ((this.berthStatus0/this.berthSum)*100).toFixed(2);

          if(this.berthSum == 0){
            this.baiFenBi = (0*100).toFixed(2);
          }

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style lang="scss" scoped>

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

.box-card {
  width: 300px;
  float: left;
  margin: 5px 0px 5px 5px;
}

.num1{
  margin-right:25px;
}
.num2{
  color:#409EFF;
  font-weight: bold;
  font-size: 19px;
}

</style>
